// extracted by css-extract-rspack-plugin
export default {"sectionTitle":"src-domain-components-system-package-version-configure-step-systemPackageVersionConfigureStep-module__sectionTitle-rZjUGv"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"sectionTitle\":\"src-domain-components-system-package-version-configure-step-systemPackageVersionConfigureStep-module__sectionTitle-rZjUGv\"}";
        // 1793705033050
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  